import { render, staticRenderFns } from "./RegistrarSolicitud.vue?vue&type=template&id=1f3ffb16&scoped=true&"
import script from "./RegistrarSolicitud.vue?vue&type=script&lang=js&"
export * from "./RegistrarSolicitud.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarSolicitud.vue?vue&type=style&index=0&id=1f3ffb16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ffb16",
  null
  
)

export default component.exports